<div class="details smallScrollbar">
  <div>
    <h3>Export as File:</h3>
    <div class="iconSetDetails">
      <mat-form-field class="exportForm" color="accent">
        <mat-label>Icon set name</mat-label>
        <input
          matInput
          type="text"
          subscriptSizing="dynamic"
          class="dense-8"
          (input)="changeName($event)"
          [value]="iconSetName | async"
        />
      </mat-form-field>
      <button
        mat-stroked-button
        class="exportForm"
        title="Export icon set"
        (click)="exportIconSet()"
      >
        <span>Export icon set</span>
      </button>
    </div>
  </div>
  <div class="actorList">
    <h3>Order of Actors:</h3>
    <mat-list>
      @for (
        iconName of selectedActors$ | async;
        track iconName;
        let i = $index
      ) {
        <mat-list-item
          class="compactItem"
          draggable="true"
          (dragover)="allowDrop($event, 'actorList')"
          (dragstart)="onDragStart(i, 'actorList')"
          (drop)="onDrop($event, iconName, true, i)"
        >
          <app-details-list-item [icon]="getIconForName(iconName)" />
        </mat-list-item>
      }
    </mat-list>
  </div>
  <div class="workobjectList">
    <h3>Order of Work Objects:</h3>
    <mat-list>
      @for (
        iconName of selectedWorkobjects$ | async;
        track iconName;
        let i = $index
      ) {
        <mat-list-item
          class="compactItem"
          draggable="true"
          (dragover)="allowDrop($event, 'workobjectList')"
          (dragstart)="onDragStart(i, 'workobjectList')"
          (drop)="onDrop($event, iconName, false, i)"
        >
          <app-details-list-item [icon]="getIconForName(iconName)" />
        </mat-list-item>
      }
    </mat-list>
  </div>
</div>
